import React from 'react';
import {ButtonBase} from '@material-ui/core';
import QCTooltip from '@pluto/qc-tooltip';
import {GoToPrevious, GoToNext} from 'VideoAudioQC/icons';

import './MarkerControls.scss';

interface MarkerControlsProps {
    onNextMarker: () => void;
    onPreviousMarker: () => void;
}

export default function MarkerControls(props: MarkerControlsProps) {
    const {onNextMarker, onPreviousMarker} = props;

    return (
        <div className="flex-container center-container">
            <QCTooltip title="Go to Previous Marker (Ctrl + Shift + C)" arrow>
                <ButtonBase
                    onClick={onPreviousMarker}
                    aria-label="Go to Previous Marker"
                    aria-keyshortcuts="Ctrl+Shift+C"
                >
                    <GoToPrevious />
                </ButtonBase>
            </QCTooltip>
            <QCTooltip title="Go to Next Marker (Shift + C)" arrow>
                <ButtonBase
                    onClick={onNextMarker}
                    aria-label="Go to Next Marker"
                    aria-keyshortcuts="(Shift + C)"
                >
                    <GoToNext />
                </ButtonBase>
            </QCTooltip>
        </div>
    );
}
